export const ticketSchema = {
  created: Date.now(),
  modified: Date.now(),
  category: 'General',
  subject: '',
  severity: 'Medium',
  priority: 'Medium',
  customerId: '',
  customerUniqueCode: '',
  details: '',
  contactPhone: '',
  status: '',
  files: []
}
